import { FilterCollectionType, SplitType } from "model/AnalyticsPage";
import {
  ETrafficFilterId,
  TRAFFIC_FILTERS_DICTIONARY,
} from "./trafficDimensions";

const AD_SLOT_SIZE_ID = ETrafficFilterId.CREATIVE_FORMAT_SIZE;
const AD_SLOT_SIZE_NAME = TRAFFIC_FILTERS_DICTIONARY[AD_SLOT_SIZE_ID].name;

// Saved reports (localStorage / shared url) store the dimension name next to its
// id, so they keep rendering the old "Creative Size" label until the split is
// re-added. Overwrite the stale name whenever a stored report is read.
export function renameAdSlotSize<
  T extends { splits?: SplitType[]; filters?: FilterCollectionType }
>(config: T): T {
  const refreshed = { ...config };

  if (config.splits) {
    refreshed.splits = config.splits.map((split) =>
      split.id === AD_SLOT_SIZE_ID
        ? { ...split, name: AD_SLOT_SIZE_NAME }
        : split
    );
  }

  const adSlotSizeFilter = config.filters?.[AD_SLOT_SIZE_ID];
  if (adSlotSizeFilter) {
    refreshed.filters = {
      ...config.filters,
      [AD_SLOT_SIZE_ID]: { ...adSlotSizeFilter, name: AD_SLOT_SIZE_NAME },
    };
  }

  return refreshed;
}
